// extracted by mini-css-extract-plugin
export var darkMode = "_2k-0";